import React from "react";

import useDecodedParams from "Hooks/useDecodedParams";
import { organizationByDescriptionIdSelector } from "Reducers/organization/organization";
import { useAppSelector } from "Store/hooks";

import Billing from "./containers/Billing";

const Page = () => {
  const { organizationId } = useDecodedParams();

  const organization = useAppSelector(state =>
    organizationByDescriptionIdSelector(state, {
      organizationDescriptionId: organizationId
    })
  );

  if (!organization) return null;

  return <Billing organization={organization} />;
};

export default Page;
